import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import Styles from "./styles.module.scss";
import logo from "../../assets/img/metasoft_logo.svg";
import flagIcon from "../../assets/img/uae-flag.svg";
import { Link } from "react-router-dom";
import Dropdownimgsocialmedia from "../../assets/img/header/dropdownimgsocialmedia.svg";
import Dropdownimgwebandmobile from "../../assets/img/header/dropdownimgwebandapp.svg";
import Dropdownimgbranding from "../../assets/img/header/dropdownimgbranding.svg";
import Dropdownimgseo from "../../assets/img/header/dropdownimgseo.svg";
import Dropdownimgit from "../../assets/img/header/dropdownimgit.svg";
import Dropdownimgmarketting from "../../assets/img/header/dropdownimgmarketing.svg";
import Dropdownimg360 from "../../assets/img/header/dropdownimg360.svg";

function Header() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const [openMenu, setOpenMenu] = useState(false);

  const toggleMenu = () => {
    setOpenMenu(!openMenu);
  };

  const [showServicesDropdown, setShowServicesDropdown] = useState(false);
  const [showProjectsDropdown, setShowProjectsDropdown] = useState(false);

  return (
    <>
      <header className={Styles.header}>
        <div className="container">
          <div className={Styles.headwrap}>
            <nav className={Styles.links}>
              <div
                className={Styles.dropdownWrapper}
                onMouseEnter={() => setShowServicesDropdown(true)}
                onMouseLeave={() => setShowServicesDropdown(false)}
              >
                <NavLink
                  to="/services"
                  className={({ isActive }) => (isActive ? Styles.active : "")}
                  onClick={scrollToTop}
                >
                  Services
                </NavLink>

                <div
                  className={Styles.dropdownMenu}
                  style={{ display: showServicesDropdown ? "grid" : "none" }}
                >
                  <NavLink
                    to="/socialmediamarketing"
                    className={Styles.menuItem}
                  >
                    <img
                      src={Dropdownimgsocialmedia}
                      alt="dropdownimgsocialmedia"
                    />
                    <div className={Styles.textBlock}>
                      <h4>Social Media Marketing</h4>
                      <p>Grow your online presence</p>
                    </div>
                    <svg
                      width="9"
                      height="14"
                      viewBox="0 0 8 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.18437 5.71067L1.23437 0.579423C1.0125 0.388798 0.6875 0.560673 0.6875 0.868486V11.131C0.6875 11.4388 1.0125 11.6107 1.23437 11.42L7.18437 6.2888C7.35469 6.14192 7.35469 5.85755 7.18437 5.71067Z"
                        fill="#888888"
                      />
                    </svg>
                  </NavLink>

                  <NavLink
                    to="/webandmobileapplication"
                    className={Styles.menuItem}
                  >
                    <img
                      src={Dropdownimgwebandmobile}
                      alt="dropdownimgwebandmobile"
                    />
                    <div className={Styles.textBlock}>
                      <h4>Web & Mobile App Development</h4>
                      <p>Turn ideas into powerful digital products</p>
                    </div>
                    <svg
                      width="8"
                      height="12"
                      viewBox="0 0 8 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.18437 5.71067L1.23437 0.579423C1.0125 0.388798 0.6875 0.560673 0.6875 0.868486V11.131C0.6875 11.4388 1.0125 11.6107 1.23437 11.42L7.18437 6.2888C7.35469 6.14192 7.35469 5.85755 7.18437 5.71067Z"
                        fill="#888888"
                      />
                    </svg>
                  </NavLink>

                  <NavLink to="/branding" className={Styles.menuItem}>
                    <img src={Dropdownimgbranding} alt="dropdownimgbranding" />
                    <div className={Styles.textBlock}>
                      <h4>Branding</h4>
                      <p>Make your brand unforgettable</p>
                    </div>
                    <svg
                      width="8"
                      height="12"
                      viewBox="0 0 8 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.18437 5.71067L1.23437 0.579423C1.0125 0.388798 0.6875 0.560673 0.6875 0.868486V11.131C0.6875 11.4388 1.0125 11.6107 1.23437 11.42L7.18437 6.2888C7.35469 6.14192 7.35469 5.85755 7.18437 5.71067Z"
                        fill="#888888"
                      />
                    </svg>
                  </NavLink>

                  <NavLink to="/seo" className={Styles.menuItem}>
                    <img src={Dropdownimgseo} alt="dropdownimgseo" />
                    <div className={Styles.textBlock}>
                      <h4>SEO Optimization</h4>
                      <p>Turn searches into traffic</p>
                    </div>
                    <svg
                      width="8"
                      height="12"
                      viewBox="0 0 8 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.18437 5.71067L1.23437 0.579423C1.0125 0.388798 0.6875 0.560673 0.6875 0.868486V11.131C0.6875 11.4388 1.0125 11.6107 1.23437 11.42L7.18437 6.2888C7.35469 6.14192 7.35469 5.85755 7.18437 5.71067Z"
                        fill="#888888"
                      />
                    </svg>
                  </NavLink>

                  <NavLink to="/itsolution" className={Styles.menuItem}>
                    <img src={Dropdownimgit} alt="dropdownimgit" />
                    <div className={Styles.textBlock}>
                      <h4>IT Solutions</h4>
                      <p>Solve problems with the right tech</p>
                    </div>
                    <svg
                      width="8"
                      height="12"
                      viewBox="0 0 8 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.18437 5.71067L1.23437 0.579423C1.0125 0.388798 0.6875 0.560673 0.6875 0.868486V11.131C0.6875 11.4388 1.0125 11.6107 1.23437 11.42L7.18437 6.2888C7.35469 6.14192 7.35469 5.85755 7.18437 5.71067Z"
                        fill="#888888"
                      />
                    </svg>
                  </NavLink>

                  <NavLink
                    to="/performancemarketing"
                    className={Styles.menuItem}
                  >
                    <img
                      src={Dropdownimgmarketting}
                      alt="dropdownimgmarkettin"
                    />
                    <div className={Styles.textBlock}>
                      <h4>Performance Marketing</h4>
                      <p>Spend smarter, convert better</p>
                    </div>
                    <svg
                      width="8"
                      height="12"
                      viewBox="0 0 8 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.18437 5.71067L1.23437 0.579423C1.0125 0.388798 0.6875 0.560673 0.6875 0.868486V11.131C0.6875 11.4388 1.0125 11.6107 1.23437 11.42L7.18437 6.2888C7.35469 6.14192 7.35469 5.85755 7.18437 5.71067Z"
                        fill="#888888"
                      />
                    </svg>
                  </NavLink>

                  <NavLink to="/photography360view" className={Styles.menuItem}>
                    <img src={Dropdownimg360} alt="dropdownimg360" />
                    <div className={Styles.textBlock}>
                      <h4>360° View Photo & Video</h4>
                      <p>Let viewers step inside your world</p>
                    </div>
                    <svg
                      width="8"
                      height="12"
                      viewBox="0 0 8 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.18437 5.71067L1.23437 0.579423C1.0125 0.388798 0.6875 0.560673 0.6875 0.868486V11.131C0.6875 11.4388 1.0125 11.6107 1.23437 11.42L7.18437 6.2888C7.35469 6.14192 7.35469 5.85755 7.18437 5.71067Z"
                        fill="#888888"
                      />
                    </svg>
                  </NavLink>
                </div>
              </div>
              {/* <NavLink
                to="/projects"
                className={({ isActive }) => (isActive ? Styles.active : "")}
                onClick={scrollToTop}
              >
                Projects
              </NavLink> */}

              {/* <div
                className={Styles.dropdownWrapper} */}
              <div
                className={`${Styles.dropdownWrapper} ${Styles.projectsDropdown}`}
                onMouseEnter={() => setShowProjectsDropdown(true)}
                onMouseLeave={() => setShowProjectsDropdown(false)}
              >
                <NavLink
                  to="/projects"
                  className={({ isActive }) => (isActive ? Styles.active : "")}
                  onClick={scrollToTop}
                >
                  Projects
                </NavLink>
                <div
                  className={Styles.dropdownMenu}
                  style={{ display: showProjectsDropdown ? "grid" : "none" }}
                >
                  <NavLink
                    to="/projects/webandmobileapplication "
                    className={Styles.menuItem}
                  >
                    <img
                      src={Dropdownimgwebandmobile}
                      alt="dropdownimgwebandmobile"
                    />
                    <div className={Styles.textBlock}>
                      <h4>Web & Mobile App Development</h4>
                      <p>Turn ideas into powerful digital products</p>
                    </div>

                    <svg
                      width="8"
                      height="12"
                      viewBox="0 0 8 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.18437 5.71067L1.23437 0.579423C1.0125 0.388798 0.6875 0.560673 0.6875 0.868486V11.131C0.6875 11.4388 1.0125 11.6107 1.23437 11.42L7.18437 6.2888C7.35469 6.14192 7.35469 5.85755 7.18437 5.71067Z"
                        fill="#888888"
                      />
                    </svg>
                  </NavLink>

                  <NavLink
                    to="/projects/digitalmarketing"
                    className={Styles.menuItem}
                  >
                    <img src={Dropdownimgseo} alt="dropdownimgseo" />
                    <div className={Styles.textBlock}>
                      <h4>Digital Marketing</h4>
                      <p>Digital marketing</p>
                    </div>
                    <svg
                      width="8"
                      height="12"
                      viewBox="0 0 8 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M7.18437 5.71067L1.23437 0.579423C1.0125 0.388798 0.6875 0.560673 0.6875 0.868486V11.131C0.6875 11.4388 1.0125 11.6107 1.23437 11.42L7.18437 6.2888C7.35469 6.14192 7.35469 5.85755 7.18437 5.71067Z"
                        fill="#888888"
                      />
                    </svg>
                  </NavLink>
                </div>
              </div>

              <NavLink
                to="/process"
                className={({ isActive }) => (isActive ? Styles.active : "")}
                onClick={scrollToTop}
              >
                Process
              </NavLink>
              {/* <NavLink to='/case-study' className={({ isActive }) => (isActive ? Styles.active : "")} onClick={scrollToTop}>CaseStudy</NavLink> */}
              <NavLink
                to="/technology"
                className={({ isActive }) => (isActive ? Styles.active : "")}
                onClick={scrollToTop}
              >
                Technology
              </NavLink>
            </nav>
            <NavLink
              to="/"
              className={Styles.logo}
              onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            >
              <img src={logo} alt="Metasoft IT Solutions" />
            </NavLink>
            <div className={Styles.menuwrap}>
              <img src={flagIcon} alt="uae flag" />
              <NavLink
                to={"/talk_us"}
                onClick={scrollToTop}
                className="btn btn-small"
              >
                Let's Talk
              </NavLink>
              {/* <a href="https://calendly.com/metasoftinfotech/15"  className="btn btn-small">Book Appointment</a> */}
              <button className={Styles.menu} onClick={toggleMenu}>
                <span></span>
                <span></span>
              </button>
            </div>
          </div>
        </div>
      </header>
      <div className={openMenu ? Styles.mobileMenuOpen : Styles.mobileMenu}>
        <button className={Styles.close} onClick={toggleMenu}>
          close
        </button>
        <div className="container">
          <div className={Styles.menuWrap}>
            <div className={Styles.mainMenu}>
              <ul>
                <li>
                  {" "}
                  <NavLink
                    to="/"
                    className={({ isActive }) =>
                      isActive ? Styles.active : ""
                    }
                    onClick={toggleMenu}
                  >
                    Home
                  </NavLink>
                </li>
                <li>
                  {" "}
                  <NavLink
                    to="/services"
                    className={({ isActive }) =>
                      isActive ? Styles.active : ""
                    }
                    onClick={toggleMenu}
                  >
                    Services
                  </NavLink>
                </li>
                <li>
                  {" "}
                  <NavLink
                    to="/projects"
                    className={({ isActive }) =>
                      isActive ? Styles.active : ""
                    }
                    onClick={toggleMenu}
                  >
                    Projects
                  </NavLink>
                </li>

                {/* <li>
                  <span
                    onClick={() =>
                      setShowProjectsDropdown(!showProjectsDropdown)
                    }
                    className={Styles.mobileParent}
                  >
                    Projects ▾
                  </span>

                  {showProjectsDropdown && (
                    <ul className={Styles.mobileSubmenu}>
                      <li>
                        <NavLink to="/projects/web" onClick={toggleMenu}>
                          Web & Mobile App Development
                        </NavLink>
                      </li>
                      <li>
                        <NavLink to="/projects/marketing" onClick={toggleMenu}>
                          Digital Marketing
                        </NavLink>
                      </li>
                    </ul>
                  )}
                </li> */}

                <li>
                  {" "}
                  <NavLink
                    to="/process"
                    className={({ isActive }) =>
                      isActive ? Styles.active : ""
                    }
                    onClick={toggleMenu}
                  >
                    Process
                  </NavLink>
                </li>
                {/* <li>   <NavLink to='/case-study' className={({ isActive }) => (isActive ? Styles.active : "")} onClick={toggleMenu}>CaseStudy</NavLink></li> */}
                <li>
                  {" "}
                  <NavLink
                    to="/technology"
                    className={({ isActive }) =>
                      isActive ? Styles.active : ""
                    }
                    onClick={toggleMenu}
                  >
                    Technology
                  </NavLink>
                </li>
              </ul>
            </div>
            <div className={Styles.subMenu}>
              <ul>
                <li>
                  <NavLink to={"/process"} onClick={toggleMenu}>
                    Process
                  </NavLink>
                </li>
                <li>
                  <NavLink to={"/clients"} onClick={toggleMenu}>
                    Clients
                  </NavLink>
                </li>
                <li>
                  <NavLink to={"/projects"} onClick={toggleMenu}>
                    Projects
                  </NavLink>
                </li>
                <li>
                  <NavLink to={"/talk_us"} onClick={toggleMenu}>
                    Careers
                  </NavLink>
                </li>

                <li>
                  {" "}
                  <NavLink to={"/technology"} onClick={toggleMenu}>
                    Technology
                  </NavLink>{" "}
                </li>
                {/* <li> <Link to="/Talk_us">Contact Us</Link> </li> */}
                <li>
                  {" "}
                  <NavLink to={"/talk_us"} onClick={toggleMenu}>
                    Contact Us
                  </NavLink>{" "}
                </li>
                <li>Metasoft 2025</li>
              </ul>
              {/* <ul>
                <li>Discover</li>
                <li>Design</li>
                <li>Build</li>
                <li>Delivery</li>
              </ul> */}
            </div>
            <div className={Styles.letsTalk}>
              <h5>Lets talk</h5>
              <h3>Lets Build a unique idea</h3>
              <p>
                We are a Web App design and development company that brings
                ideas to life through scalable, sustainable and futuristic
                solutions.
              </p>
              <NavLink
                to={"/talk_us"}
                className="btn btn-territory"
                onClick={toggleMenu}
              >
                Contact Us
              </NavLink>
            </div>
          </div>
        </div>
        <div className={Styles.socialmenu}>
          <div className="container">
            <div className={Styles.mobMenuWrap}>
              <div className={Styles.socialWrap}>
                <Link
                  target="_blank"
                  to="https://www.linkedin.com/company/31008439/admin"
                >
                  LinkedIn
                </Link>
                <Link
                  target="_blank"
                  to="https://www.instagram.com/metasoft_it/"
                >
                  Instagram
                </Link>
                <Link
                  target="_blank"
                  to="https://www.facebook.com/metasoftitsolutions"
                >
                  Facebook
                </Link>
                <Link target="_blank" to="https://twitter.com/Metasoft_it">
                  Twitter
                </Link>
                {/* <a href="#">WhatsApp</a> */}
              </div>
              <div className={Styles.locations}>
                <span>UAE</span>
                <span>Qatar</span>
                <span>KSA</span>
                <span>India</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Header;
